module.exports = __webpack_public_path__ + "static/media/edit-button.427e3107.svg";